import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './user-banner.module.css';

export function DirectorySyncUsersBanner() {
    return (
        <div className={styles.container}>
            <FlashBanner type='info' hasBorder={true}>
                <div className='flex justify-sb align-center full-width'>
                    <div className={styles['body-container']}>
                        <Body color='blue'>
                            Directory sync is turned on - to add or remove managed users from
                            Nutshell, you’ll need to make changes within your company’s directory.
                        </Body>
                    </div>
                    {/* @ts-expect-error */}
                    <Link as={RoutedLink} to='/setup/security' variant='primary'>
                        Configure
                    </Link>
                </div>
            </FlashBanner>
        </div>
    );
}
